document.addEventListener("DOMContentLoaded", () => {

    const mainCart = document.querySelector("#hgp-main-cart");

    if (!mainCart) return;


    /* =========================================================
       HELPERS
    ========================================================= */

    function getMoneyValue(value) {

        const number = Number(value);

        return Number.isFinite(number)
            ? number
            : 0;

    }


    /* =========================================================
       GET PACK SIZE

       Examples:
       Pack of 2
       Set of 3
       Pack of 4

       If nothing is found:
       pack size = 1
    ========================================================= */

    function getPackSize(item) {

        const title =
            item.variant_title ||
            item.product_title ||
            "";

        const packMatch =
            title.match(
                /(?:set|pack)\s*(?:of)?\s*(\d+)/i
            );

        if (packMatch) {

            return Number(packMatch[1]);

        }

        return 1;

    }


    /* =========================================================
       CALCULATE SAME DYNAMIC DISCOUNT
       AS PRODUCT / SIDEBAR LOGIC
    ========================================================= */

    function calculateDynamicPrice(item, newQuantity) {

        const properties =
            item.properties || {};


        /*
         * ORIGINAL PRICES
         *
         * compare_price is stored in paise.
         */

        const comparePerPack =
            getMoneyValue(
                properties.compare_price
            );


        /*
         * Original selling price.
         *
         * IMPORTANT:
         * For quantity = 1 we should use
         * Shopify's original selling price.
         */

        const originalSellingPerPack =
            getMoneyValue(
                item.original_price
            );


        /*
         * PACK SIZE
         */

        const packSize =
            getPackSize(item);


        /*
         * TOTAL INDIVIDUAL UNITS
         */

        const totalUnits =
            packSize * newQuantity;


        /*
         * DYNAMIC DISCOUNT
         */

        let discount = 0;

        if (newQuantity > 1) {

            discount =
                Math.min(
                    40,
                    totalUnits * 5
                );

        }


        /*
         * FINAL SELLING PRICE
         *
         * QTY = 1
         *
         * Use original Shopify selling price.
         */

        let finalSellingPerPack;

        if (newQuantity === 1) {

            finalSellingPerPack =
                originalSellingPerPack;

        }


        /*
         * QTY > 1
         *
         * Apply dynamic discount to
         * ORIGINAL COMPARE PRICE.
         */

        else {

            const finalMRP =
                comparePerPack *
                newQuantity;


            const finalTotal =
                finalMRP *
                (
                    1 -
                    discount / 100
                );


            finalSellingPerPack =
                Math.round(
                    finalTotal /
                    newQuantity
                );

        }


        return {

            packSize,

            totalUnits,

            discount,

            comparePerPack,

            finalSellingPerPack

        };

    }


    /* =========================================================
       GET CURRENT CART
    ========================================================= */

    async function getCart() {

        const response =
            await fetch(
                "/cart.js",
                {
                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );

        if (!response.ok) {

            throw new Error(
                "Unable to fetch cart"
            );

        }

        return await response.json();

    }
 

    /* =========================================================
       UPDATE CART ITEM
    ========================================================= */

    async function updateCartItem(cartKey, newQuantity) {
        // Shopify calculates the line price. We change quantity only.
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: cartKey,
                quantity: Math.max(0, Number(newQuantity) || 0)
            })
        });

        if (!response.ok) {
            throw new Error("Unable to update cart");
        }

        return response.json();
    }


    /* =========================================================
       LOADING STATE
    ========================================================= */

    function setItemLoading(
        cartKey,
        isLoading
    ) {

        const cartItem =
            document.querySelector(
                `.hgp-main-cart-item[data-cart-key="${cartKey}"]`
            );


        if (!cartItem) return;


        cartItem.classList.toggle(
            "is-loading",
            isLoading
        );


        const buttons =
            cartItem.querySelectorAll(
                "button"
            );


        buttons.forEach(
            button => {

                button.disabled =
                    isLoading;

            }
        );

    }


    /* =========================================================
       REFRESH PAGE

       For now we use a page refresh.

       This is intentional because Liquid calculates
       all updated prices, savings and totals again
       using the updated cart properties.

       Later, if needed, we can convert this to
       fully AJAX rendering.
    ========================================================= */

    function refreshMainCart() {

        window.location.reload();

    }


    /* =========================================================
       QUANTITY BUTTONS
    ========================================================= */

    document.addEventListener(
        "click",
        async event => {

            const quantityButton =
                event.target.closest(
                    ".hgp-main-cart-qty-btn"
                );


            if (!quantityButton) return;


            const cartKey =
                quantityButton.dataset.cartKey;


            const action =
                quantityButton.dataset.action;


            const cartItem =
                document.querySelector(
                    `.hgp-main-cart-item[data-cart-key="${cartKey}"]`
                );


            if (!cartItem) return;


            const quantityElement =
                cartItem.querySelector(
                    ".hgp-main-cart-qty-value"
                );


            const currentQuantity =
                Number(
                    quantityElement?.textContent
                ) || 1;


            let newQuantity =
                currentQuantity;


            if (
                action === "increase"
            ) {

                newQuantity =
                    currentQuantity + 1;

            }


            if (
                action === "decrease"
            ) {

                newQuantity =
                    currentQuantity - 1;

            }


            try {

                setItemLoading(
                    cartKey,
                    true
                );


                await updateCartItem(
                    cartKey,
                    newQuantity
                );


                refreshMainCart();

            }

            catch (error) {

                console.error(
                    "Main cart update error:",
                    error
                );


                setItemLoading(
                    cartKey,
                    false
                );

            }

        }
    );


    /* =========================================================
       REMOVE BUTTON
    ========================================================= */

    document.addEventListener(
        "click",
        async event => {

            const removeButton =
                event.target.closest(
                    ".hgp-main-cart-remove"
                );


            if (!removeButton) return;


            const cartKey =
                removeButton.dataset.cartKey;


            if (!cartKey) return;


            try {

                setItemLoading(
                    cartKey,
                    true
                );


                await updateCartItem(
                    cartKey,
                    0
                );


                refreshMainCart();

            }

            catch (error) {

                console.error(
                    "Remove cart item error:",
                    error
                );


                setItemLoading(
                    cartKey,
                    false
                );

            }

        }
    );


    /* =========================================================
       CHECKOUT
    ========================================================= */

    document.addEventListener(
        "click",
        event => {

            const checkoutButton =
                event.target.closest(
                    "#hgp-main-cart-checkout"
                );


            if (!checkoutButton) return;


            window.location.href =
                "/checkout";

        }
    );

}); 